interface FaqItem {
  q: string;
  a: string;
}

const faqItems: FaqItem[] = [
  {
    q: '吃瓜网每日大赛是什么？',
    a: '吃瓜网每日大赛是一个专注于娱乐八卦资讯聚合的中文互联网平台，提供最新明星爆料、综艺内幕、行业黑幕等内容。我们每日更新大赛排名，让瓜友们一站式掌握最全吃瓜动态。',
  },
  {
    q: '如何找到吃瓜网每日大赛的最新入口地址？',
    a: '吃瓜网每日大赛官网入口地址会定期更新以确保安全访问。建议您收藏本站首页，或关注我们的官方社交媒体账号，获取最新的吃瓜网入口与最新地址通知。',
  },
  {
    q: '吃瓜网每日大赛的内容是否真实可靠？',
    a: '我们坚持「有料不造谣」原则，所有爆料内容均经过多方核实。对于暂未完全证实的传闻，我们会明确标注「待核实」标签，绝不为了流量传播虚假信息。我们的内容准确率保持在99.7%以上。',
  },
  {
    q: '吃瓜网每日大赛网站访问安全吗？',
    a: '是的。我们采用HTTPS加密传输，确保您的访问安全。建议通过本站提供的吃瓜网入口访问，避免使用来路不明的第三方链接，以防被钓鱼网站或恶意软件侵害。',
  },
  {
    q: '如何向吃瓜网每日大赛投稿爆料？',
    a: '欢迎通过本站「爆料投稿」区域的微信通道或电子邮箱（tips@chiguawang.com）向我们提供线索。我们对所有爆料人信息严格保密，您的每一条线索都可能成为明天的头条大瓜。',
  },
  {
    q: '吃瓜网每日大赛每天什么时候更新内容？',
    a: '吃瓜网每日大赛实行24小时滚动更新机制，全天候追踪娱乐圈最新动态。我们的编辑团队覆盖早中晚三个班次，确保您随时随地打开网站都能看到最新的吃瓜资讯。',
  },
];

const SectionFaq = () => (
  <section id="faq" className="py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
        <p className="mt-2 text-sm text-foreground-500">关于吃瓜网每日大赛，你想知道的都在这里</p>
      </div>
      <div className="max-w-[800px] mx-auto grid grid-cols-1 gap-3">
        {faqItems.map((item) => (
          <div key={item.q} className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6">
            <h3 className="text-base font-semibold text-foreground-900">{item.q}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SectionFaq;